<!-- 分离日期区间选择 -->
<template>
  <el-form-item class="date-separate-range" :label="label">
    <el-date-picker
      v-model="dateModel.startDate"
      type="date"
      placeholder="开始"
      value-format="YYYY-MM-DD"
      :disabledDate="startDisabledDate"
      class="picker"
      @change="$emit('change', $event)"
    >
    </el-date-picker>
    <div class="input-range-divider"></div>
    <el-date-picker
      v-model="dateModel.endDate"
      type="date"
      placeholder="结束"
      value-format="YYYY-MM-DD"
      :disabledDate="endDisabledDate"
      class="picker"
      @change="$emit('change', $event)"
    >
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-分离日期区间选择',
  props: {
    // 初始值.
    value: {
      type: [Object],
      default() {
        return {
          startDate: '',
          endDate: '',
        };
      },
    },
    startDisabledDate: Function,
    endDisabledDate: Function,
    label: {
      type: String,
      default: '有效期：',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    validator: Function,
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const dateModel = useQuery('dateRange', props.value);
    return {
      dateModel,
    };
  },
};
</script>
<style lang="scss">
.date-separate-range {
  .input-range-divider {
    display: inline-block;
    width: 7px;
    height: 1px;
    background: #c0c4cc;
    margin: 0 7px 4px 7px;
  }
  .picker {
    width: 100px !important;
  }
  .el-date-editor .el-input__prefix {
    display: none;
  }
}
</style>
